"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeCheckAndSelect = exports.ChipContext = void 0;
var _react = require("react");
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var ChipContext = exports.ChipContext = /*#__PURE__*/(0, _react.createContext)({
  defaultSelected: undefined,
  name: undefined,
  onCheck: undefined,
  required: undefined,
  selected: undefined,
  selectedColor: undefined,
  size: undefined,
  type: undefined
});
var mergeCheckAndSelect = exports.mergeCheckAndSelect = function mergeCheckAndSelect(checked, selected, value) {
  if (checked !== undefined) {
    return checked;
  }
  if (selected !== undefined) {
    return selected === value;
  }
  return undefined;
};